// F-63b: fit the notes sheet to the VISIBLE viewport while the on-screen keyboard is up (iPad standalone).
// The overlay is position:fixed (so it sits in the layout viewport) and is the scroller (F-63). When the keyboard opens, iPadOS shrinks
// the visual viewport and may pan it (visualViewport.offsetTop > 0) and report a shorter innerHeight by the same amount. A bottom offset
// computed as innerHeight - vv.height - vv.offsetTop counts that pan twice (run 5, 2026-10-18: overlay 490/458/426 px tall against a 406 px
// visible area). So the overlay is sized from the visual viewport itself: top = vv.offsetTop, height = vv.height. innerHeight is only used
// to notice that a keyboard is probably up; it never enters the geometry.
const KB_MIN = 40; // px of lost height that counts as "a keyboard (or its shortcut bar) is up"

// → { top, height } in px, or null when the overlay should keep its stylesheet geometry (inset:0): keyboard down, pinch-zoomed, or no visualViewport.
export function fitFor(vv, innerH){
  if(!vv) return null;
  if(vv.scale && vv.scale > 1.01) return null;                     // pinch-zoomed: vv.height shrinks for another reason
  const up = (innerH - vv.height) > KB_MIN || vv.offsetTop > 1;
  if(!up) return null;
  return { top: Math.round(vv.offsetTop), height: Math.round(vv.height) };
}

function _apply(ov, f){
  if(f){ ov.style.setProperty('top', f.top + 'px'); ov.style.setProperty('height', f.height + 'px'); ov.style.setProperty('bottom', 'auto'); }
  else { ov.style.removeProperty('top'); ov.style.removeProperty('height'); ov.style.removeProperty('bottom'); }
}

// Fit `ov` now and on every visualViewport resize/scroll and every focus inside it. Returns detach(): removes every listener it added and
// restores the stylesheet geometry. The element is looked up from the argument at call time, never from an earlier sheet.
export function attachKbFit(ov, win){
  const vv = win && win.visualViewport;
  if(!vv || !ov) return () => {};
  let raf = 0;
  const run = () => { if(ov) _apply(ov, fitFor(vv, win.innerHeight)); };
  const onFocus = () => { run(); if(win.requestAnimationFrame){ if(raf && win.cancelAnimationFrame) win.cancelAnimationFrame(raf); raf = win.requestAnimationFrame(run); } }; // iOS pans the viewport just after focus
  vv.addEventListener('resize', run); vv.addEventListener('scroll', run);
  ov.addEventListener('focusin', onFocus);
  run();
  return function detach(){
    vv.removeEventListener('resize', run); vv.removeEventListener('scroll', run);
    ov.removeEventListener('focusin', onFocus);
    if(raf && win.cancelAnimationFrame) win.cancelAnimationFrame(raf);
    _apply(ov, null);
    ov = null;
  };
}
